import {
  REDIRECTING
} from '../actions/login-actions'

export default (state = false, action) => {
  switch (action.type) {
  case REDIRECTING:
    return true
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/redirecting.js